'use client';

import { motion } from 'framer-motion';
import { usePriceConvert } from '@/lib/PriceContext';
import { fadeUp } from '@/v4/theme/motion';

type Lang = 'uk' | 'ru' | 'en';

const T: Record<string, Record<Lang, string>> = {
  heading: { uk: 'Підписки', ru: 'Подписки', en: 'Subscriptions' },
  soon:    { uk: 'Незабаром', ru: 'Скоро', en: 'Coming soon' },
  gpTitle: { uk: 'Xbox Game Pass', ru: 'Xbox Game Pass', en: 'Xbox Game Pass' },
  gpDesc: {
    uk: 'Понад 1 000 ігор за єдиною підпискою. Нові тайтли щомісяця, включно з прем’єрами в день виходу.',
    ru: 'Более 1 000 игр по единой подписке. Новые тайтлы каждый месяц, включая премьеры в день выхода.',
    en: 'Over 1,000 games in a single subscription. New titles every month, including day-one releases.',
  },
  eaTitle: { uk: 'EA Play', ru: 'EA Play', en: 'EA Play' },
  eaDesc: {
    uk: 'Найкращі ігри від EA, ранній доступ до нових релізів і ексклюзивні знижки на покупки.',
    ru: 'Лучшие игры от EA, ранний доступ к новым релизам и эксклюзивные скидки на покупки.',
    en: 'The best EA games, early access to new releases, and exclusive purchase discounts.',
  },
  more: { uk: 'Дізнатись більше', ru: 'Узнать больше', en: 'Learn more' },
};

export function SubscriptionBlock() {
  const { lang: raw } = usePriceConvert();
  const lang: Lang = (['uk', 'ru', 'en'].includes(raw) ? raw : 'en') as Lang;
  const tr = (k: string) => T[k][lang];

  return (
    <motion.section {...fadeUp()}>
      <div className="v4home-sec-hd">
        <h2 className="v4home-sec-title">{tr('heading')}</h2>
      </div>
      <div className="v4home-sub-grid">
        <div className="v4home-sub">
          <div className="v4home-sub__glow" style={{ background: 'var(--v4-glow-emerald)' }} />
          <span className="v4home-sub-badge">{tr('soon')}</span>
          <div className="v4home-sub-logo" style={{ color: 'var(--v4-emerald-3)' }}>GAME<br />PASS</div>
          <h3 className="v4home-sub-title">{tr('gpTitle')}</h3>
          <p className="v4home-sub-desc">{tr('gpDesc')}</p>
          <button className="v4home-sub-btn" disabled aria-disabled="true">{tr('more')}</button>
        </div>

        <div className="v4home-sub">
          <div className="v4home-sub__glow" style={{ background: 'var(--v4-glow-emerald)' }} />
          <span className="v4home-sub-badge">{tr('soon')}</span>
          <div className="v4home-sub-logo" style={{ color: 'var(--gs-green)' }}>EA<br />PLAY</div>
          <h3 className="v4home-sub-title">{tr('eaTitle')}</h3>
          <p className="v4home-sub-desc">{tr('eaDesc')}</p>
          <button className="v4home-sub-btn" disabled aria-disabled="true">{tr('more')}</button>
        </div>
      </div>
    </motion.section>
  );
}
